var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IsEnum, IsNumberString, IsOptional, IsString, IsUUID, Length } from "class-validator";
import { GFIDProvider } from "./healthcareorganization.dtos";
import { VERIFICATION_DEFAULT_OTP_LENGTH } from "./verification.dtos";
export var LoginStateScreen;
(function (LoginStateScreen) {
    LoginStateScreen["CLEAR_REAUTH"] = "CLEAR_REAUTH";
    LoginStateScreen["CLEAR_LOGIN"] = "CLEAR_LOGIN";
    LoginStateScreen["SOCIAL_REAUTH"] = "SOCIAL_REAUTH";
    LoginStateScreen["STANDARD_LOGIN"] = "STANDARD_LOGIN";
})(LoginStateScreen || (LoginStateScreen = {}));
export class LoginStateResponse {
}
__decorate([
    IsEnum(LoginStateScreen)
], LoginStateResponse.prototype, "screen", void 0);
__decorate([
    IsOptional(),
    IsEnum(GFIDProvider)
], LoginStateResponse.prototype, "provider", void 0);
__decorate([
    IsOptional(),
    IsString()
], LoginStateResponse.prototype, "maskedPhone", void 0);
__decorate([
    IsOptional(),
    IsString()
], LoginStateResponse.prototype, "firstName", void 0);
export class SendOtpResponse {
}
__decorate([
    IsUUID()
], SendOtpResponse.prototype, "reauthKey", void 0);
__decorate([
    IsString()
], SendOtpResponse.prototype, "maskedPhone", void 0);
export class VerifyOtpInput {
}
__decorate([
    IsUUID()
], VerifyOtpInput.prototype, "reauthKey", void 0);
__decorate([
    IsNumberString({}, { message: "Verification code must contain only numbers" }),
    Length(VERIFICATION_DEFAULT_OTP_LENGTH, VERIFICATION_DEFAULT_OTP_LENGTH)
], VerifyOtpInput.prototype, "code", void 0);
